<template>
  <div class="orders">
    <div class="orderMain">
      <div class="infosearch">
        <el-input v-model="relateName" placeholder="输入盘点相关人搜索" style="width: 220px;margin-right: 20px"></el-input>
        <span class="labelTit">盘点范围</span>
        <el-select v-model="scope" placeholder="请选择盘点范围" style="width:160px;margin-right: 20px">
          <el-option label="全盘" :value="''"></el-option>
          <el-option label="单次服务商品" value="1"></el-option>
          <el-option label="整套服务商品" value="2"></el-option>
          <el-option label="零售商品" value="3"></el-option>
        </el-select>
        <span class="labelTit">盘点时间</span>
        <el-date-picker v-model="orderTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" style="width: 260px;margin-right: 10px"></el-date-picker>
        <el-button class="searchBtn"  @click="enterSeach"></el-button>
        <el-button class="addMems" @click="addCheckList">新增盘点单</el-button>
      </div>
      <el-table v-if="tableData.length > 0" :data="tableData" height="582" ref="multipleTable" class="myMemTable" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
        <el-table-column align="center" type="index" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="id" label="盘点单号"></el-table-column>
        <el-table-column align="center" label="盘点范围">
          <template slot-scope="scope">{{scope.row.scope == 'all' ? '全盘':(scope.row.scope == 1 ? '单次服务商品':(scope.row.scope == 2 ? '整套服务商品':'零售服务商品'))}}</template>
        </el-table-column>
        <el-table-column align="center" prop="normalNum" label="盘点商品数">
          <template slot-scope="scope">{{(scope.row.normalNum + scope.row.abnormalNum) | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="source" label="盘点结果">
          <template
            slot-scope="scope"
          >{{('正常'+scope.row.normalNum+'个' + '异常'+scope.row.abnormalNum+'个') | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="operatorName" label="盘点人"></el-table-column>
        <el-table-column align="center" prop="examinerName" label="检查人"></el-table-column>
        <el-table-column align="center" prop="noteTakerName" label="记录人"></el-table-column>
        <el-table-column align="center" prop="createTime" label="盘点时间" width="150"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="toView(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到库存盘点信息！再核对一下试试</div>
      </template>
      <el-pagination v-if="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;text-align:right"></el-pagination>
    </div>
  </div>
</template>
<script type="text/javascript">
import { stockTakingList } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      relateName: "",
      orderTime: "",
      scope: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0
    };
  },
  created() {
    this.search();
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  activated() {
  	this.search();
  	this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  methods: {
    async search(val) {
      if (val == 1) {
        this.currentPage = 1;
      }
      let res = await stockTakingList({
        scope:this.scope,
        relateName: this.relateName,
        startDate: this.orderTime ? this.orderTime[0] : "",
        endDate: this.orderTime ? this.orderTime[1] : "",
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      });
      if (res.code == 1) {
        this.total = res.data.total;
        this.tableData = res.data.rows;
      }
    },
    enterSeach() {
      this.currentPage = 1;
      this.search();
    },
    addCheckList() {
      // 新增盘点单
      this.$router.push("/businessManagementCenter/addInventory");
    },
    toView(id) {
      this.$router.push("/businessManagementCenter/inventorView/" + id);
      this.$store.commit('setAlivePage',this.currentPage)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },

  }
};
</script>
<style lang="less" scoped>
.orderMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .el-button--mini {
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.orderMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/inventory.vue